// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Filters-module--wrapper--3i7vy"};